/* eslint-disable import/prefer-default-export */

export const yesNoOptions = [
  { label: "Yes", value: "true" },
  { label: "No", value: "false" },
];

export const borrowerEntityOptions = [
  {
    label: "Borrower 1",
    value: 1,
  },
  {
    label: "Borrower 2",
    value: 2,
  },
  {
    label: "Both",
    value: 3,
  },
];

export const ADDRESS_DELIM = "~|~"; // HACK: jjw

// Since documents are updated by generating diff objects (comparable to redux actions) we can use this field to signify that we want to DELETE a value.
export const MARK_FOR_DELETION = "";
